"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debounceAsync = debounceAsync;
exports.default = debounce;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

function debounce(func, delay) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$leading = _ref.leading,
      leading = _ref$leading === void 0 ? false : _ref$leading;

  var timerId = null;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (!timerId && leading) {
      func.apply(void 0, args);
    }

    if (timerId) {
      clearTimeout(timerId);
    }

    timerId = setTimeout(function () {
      timerId = null;
      func.apply(void 0, args);
    }, delay);
  };
}

function debounceAsync(func, delay) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref2$leading = _ref2.leading,
      leading = _ref2$leading === void 0 ? false : _ref2$leading;

  var timerId = null;
  return /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var _len2,
        args,
        _key2,
        _args = arguments;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            for (_len2 = _args.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = _args[_key2];
            }

            _context.next = 3;
            return new Promise(function (resolve, reject) {
              if (!timerId && leading) {
                func.apply(void 0, args).then(resolve).catch(reject);
              }

              if (timerId) {
                clearTimeout(timerId);
              }

              timerId = setTimeout(function () {
                timerId = null;
                func.apply(void 0, args).then(resolve).catch(reject);
              }, delay);
            });

          case 3:
            return _context.abrupt("return", _context.sent);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}